import { cn } from '@/lib/utils';
import type { CMSQueueCount } from '../schemas';
import { useMemo } from 'react';

interface CMSQueueCountProps {
  queueCountData: CMSQueueCount;
  className?: string;
}

const CMSQueueCount = ({ queueCountData, className }: CMSQueueCountProps) => {
  const labelPosition = queueCountData.label_position.key;
  const label = queueCountData.label;

  // random 2 to 9
  const random = useMemo(() => Math.floor(Math.random() * (9 - 2 + 1)) + 2, []);
  return (
    <div
      className={cn('w-full  font-nunito700 text-sm  md:text-base', className)}
      data-component="CMSQueueCount"
    >
      {labelPosition === 'left' ? (
        <span className="text-green-600">
          <label>{label}</label> {random}
        </span>
      ) : (
        <span className="text-green-600">
          {random} <label>{label}</label>
        </span>
      )}
    </div>
  );
};

export { CMSQueueCount };
